import { render, staticRenderFns } from "./ZProgressBarVertical.vue?vue&type=template&id=2fbfb088&scoped=true&"
import script from "./ZProgressBarVertical.vue?vue&type=script&lang=js&"
export * from "./ZProgressBarVertical.vue?vue&type=script&lang=js&"
import style0 from "./ZProgressBarVertical.vue?vue&type=style&index=0&id=2fbfb088&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbfb088",
  null
  
)

export default component.exports